import MainLayout from "@/components/layout/admin/MainLayout.vue";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
import Select2Multiple from 'v-select2-multiple-component';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import HandlePaginateService from "@/services/HandlePaginateService";

export default {
  name: 'HostelDetail',
  components: {
    MainLayout,
    Loading,
    Select2Multiple,
    AdvancedLaravelVuePaginate
  },
  data() {
    return {
      hostelData: {},
      boarderData: {},
      newBoarderCode: '',
      foundOwner: null,
      submitted: false,
      isLoading: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      periodArr: [],
      selectedAcademicYear: null,
      isSearchBoarder: false,
    }
  },

  methods: {
    getDetail() {
      this.isLoading = true;
      axios.get(`hostel/detail/${this.$route.params.id}`)
        .then(res => {
          if (res.data) {
            this.hostelData = res.data;
          }
        })
        .catch(error => {
          console.error("Error fetching hostel details:", error);
        })
        .finally(() => this.isLoading = false);
    },

    getBoarders(page = 1) {
      this.isLoading = true;
      axios.get(`hostelBoarders/${this.$route.params.id}?page=` + page)
        .then(res => {
          this.boarderData = res.data;
        })
        .catch(error => {
          console.error("Error fetching boarders:", error);
        })
        .finally(() => this.isLoading = false);
    },

    getAcademicYear() {
      axios.get('period/periodList')
        .then(res => {
          this.periodArr = res.data.data;
        }).catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    searchBoarders(page = 1) {
      this.isSearchBoarder = true;
      if (!this.selectedAcademicYear) {
        this.getBoarders();
        return;
      }
      this.isLoading = true;
      axios.get(`hostelBoarders/${this.$route.params.id}/search/${this.selectedAcademicYear}?page=` + page)
        .then(res => {
          this.boarderData = res.data;
        })
        .catch(error => {
          console.error("Error searching boarders:", error);
        })
        .finally(() => this.isLoading = false);
    },

    resetSearch() {
      this.selectedAcademicYear = null;
      this.isSearchBoarder = false;
      this.getBoarders();
    },

    handleBoarderPaginate(page) {
      HandlePaginateService.paginate({
        page,
        isSearch: this.isSearchBoarder,
        searchFn: this.searchBoarders,
        listFn: this.getBoarders
      })
    },

    findUserByCode() {
      if (!this.newBoarderCode) {
        this.foundOwner = null;
        return;
      }
      axios.get(`hostelBoarders/findUser/${this.newBoarderCode}`)
        .then(res => {
          this.foundOwner = res.data;
        })
        .catch(error => {
          this.foundOwner = null;
          console.error("User not found:", error);
        });
    },

    addBoarder() {
      this.submitted = true;
      if (!this.newBoarderCode) {
        return;
      }
      this.isLoading = true;
      axios.post(`hostelBoarders/${this.$route.params.id}`, { code: this.newBoarderCode })
        .then(() => {
          this.getBoarders();
          this.newBoarderCode = '';
          this.submitted = false;
          this.$notification.success("Boarder Added Successfully", { timer: 3, position: "bottomCenter" });
        })
        .catch(error => {
          let errorMsg = "Something went wrong while adding the boarder.";
          if (error.response && error.response.data && error.response.data.message) {
            errorMsg = error.response.data.message;
          }
          this.$notification.error(errorMsg, { timer: 3, position: "bottomCenter" });
        })
        .finally(() => this.isLoading = false);
    },

    removeBoarder(boarderId) {
      this.isLoading = true;
      axios.delete(`hostelBoarders/${boarderId}`)
        .then(() => {
          this.getBoarders();
          this.$notification.success("Boarder Removed Successfully", { timer: 3, position: "bottomCenter" });
        })
        .catch(() => {
          this.$notification.error("Something went wrong while removing the boarder.", { timer: 3, position: "bottomCenter" });
        })
        .finally(() => this.isLoading = false);
    },

    confirmDelete(boarderId) {
      if (window.confirm('Are you sure you want to remove this boarder?')) {
        this.removeBoarder(boarderId);
      }
    }
  },
  mounted() {
    this.getDetail();
    this.getBoarders();
    this.getAcademicYear();
  },
}
